import { LoadingState } from '../../../../types/loading-state';
import { compactMap } from '../../../../utils/array-utils';
import { createFetchedData } from '../../../../utils/fetched-data/create-fetched-data';
import { getFetchedDataPayload } from '../../../../utils/fetched-data/get-fetched-data-payload';
import { getFilterByIdAndType } from '../../../filter/selectors/get-filter-by-id-and-type';
import { FilterType } from '../../../filter/types/filter-type';
import { filterShowtimes } from '../../../filter/utils/filter-showtimes';
import { getShowtimesQuery } from '../../utils/showtimes/get-showtimes-query';
import { getShowtimeById } from './get-showtime-by-id';
import { getShowtimeIdsForQueryOnBusinessDate } from './get-showtime-ids-for-query-on-business-date';
export const getAllShowtimes = (businessDate, filmIds, siteIds, filterId) => {
    const showtimesQuery = getShowtimesQuery(filmIds, siteIds);
    const showtimeIdsForDate = businessDate
        ? getShowtimeIdsForQueryOnBusinessDate(showtimesQuery, businessDate)
        : createFetchedData(LoadingState.NotLoaded);
    const showtimeIds = getFetchedDataPayload(showtimeIdsForDate);
    const showtimes = showtimeIds ? compactMap(showtimeIds, showtimeId => getShowtimeById(showtimeId)) : [];
    const filter = filterId && getFilterByIdAndType(filterId, FilterType.Showtime);
    return filter ? filterShowtimes(filter, showtimes) : showtimes;
};
